<template>
  <div>
    <header>
      <a-row>
        <a-col :span="4">
          <a class="return-course" href="/student/course"
            ><a-icon type="double-left" /> 返回课程</a
          >
        </a-col>
        <a-col :span="12">
          <h2 class="lesson-title">
            {{ courseInfo.courseName }}
            <span class="lesson-type">
              {{ courseInfo.courseType_dictText }}
            </span>
            <span class="lesson-type">
              {{ courseInfo.courseLevel_dictText }}
            </span>
          </h2>
        </a-col>
        <a-col :span="8">
          <a
            class="lesson-download"
            v-if="getCoursewareByType(6).mediaPath_url"
            :href="getCoursewareByType(6).mediaPath_url"
            target="_blank"
            ><a-icon type="download" />课程素材包下载</a
          >
          <!-- <span
            class="btn-wrap"
            v-show="
              showUnitInfo &&
              selectedUnitType == 2 &&
              selectedUnit.isWorkOpen == 1 &&
              getCoursewareByType(5).mediaPath_url
            "
          >
            <a-button
              type="primary"
              style="height: 34px; line-height: 34px"
              @click="handleViewMediaCode(5, false)"
              >去做作业</a-button
            >
          </span> -->
          <!-- <span
            class="btn-wrap"
            v-show="
              showUnitInfo &&
              selectedUnitType == 1 &&
              selectedUnit.isWorkCaseOpen == 1 &&
              getCoursewareByType(3).mediaPath_url
            "
          >
            <a-button
              type="primary"
              style="height: 34px; line-height: 34px"
              @click="handleViewMediaCode(3, false)"
              >去做练习</a-button
            >
          </span> -->
        </a-col>
      </a-row>
    </header>
    <a-layout class="course-prepare-layout">
      <a-layout-content
        :style="{
          background: '#fff',
          padding: '24px',
          margin: 0,
          height: 'calc(100vh - 64px)',
          overflow: 'auto',
        }"
      >
        <a-spin :spinning="spinning">
          <div class="course-info" v-if="showCourseInfo">
            <a-row>
              <a-col :span="4" style="text-align: right"
                ><h3 class="course-meta-title">课程名称：</h3></a-col
              >
              <a-col :span="20" class="course-meta-value">{{
                courseInfo.courseName
              }}</a-col>
            </a-row>
            <a-row>
              <a-col :span="4" style="text-align: right"
                ><h2 class="course-meta-title">课程难度：</h2></a-col
              >
              <a-col :span="20" class="course-meta-value">{{
                courseInfo.courseLevel_dictText
              }}</a-col>
            </a-row>
            <a-row>
              <a-col :span="4" style="text-align: right"
                ><h2 class="course-meta-title">课程简介：</h2></a-col
              >
              <a-col :span="20" class="course-meta-value">{{
                courseInfo.courseDesc
              }}</a-col>
            </a-row>
            <a-row>
              <a-col :span="4" style="text-align: right"
                ><h2 class="course-meta-title">教学大纲：</h2></a-col
              >
              <a-col :span="24"
                ><img :src="courseInfo.courseOutline_url" alt=""
              /></a-col>
            </a-row>
          </div>
          <div class="unit-info" v-if="showUnitInfo">
            <a-card v-if="selectedUnitType == 1">
              <div
                v-if="
                  getCoursewareByType(1).mediaPath_url &&
                  selectedUnit.isVideoOpen == 1
                "
              >
                <h1 style="text-align: center">课堂视频</h1>
                <video
                  oncontextmenu="return false;"
                  class="unit-video"
                  :src="getCoursewareByType(1).mediaPath_url"
                  :poster="getCoursewareByType(3).mediaCover_url"
                  controls
                  controlsList='nodownload noremote footbar'
                ></video>
              </div>
            </a-card>
            <div v-for="(v, i) in getCoursewareListByType(3)" :key="i">
              <a-card v-if="selectedUnitType == 1">
                <h1 class="unit-name">课堂案例 {{i+1}}</h1>
                <h3>{{v.mediaName}}</h3>
                <a-divider></a-divider>
                <p class="unit-desc">
                  {{ selectedUnit.unitIntro }}
                </p>
                <div
                  v-if="
                    v.mediaPath_url &&
                    selectedUnit.isWorkCaseOpen == 1
                  "
                >
                  <iframe
                    :src="handlePreviewMediaCode(v)"
                    id="courseCaseFrameRef"
                    frameborder="0"
                    width="100%"
                  ></iframe>
                  <a-button
                    type="primary"
                    style="height: 34px; line-height: 34px;display: block;margin: auto;"
                    @click="handleViewMediaCode(v, false)"
                    >去做练习</a-button>
                </div>

                <!-- <img
                  class="unit-cover"
                  :src="getCoursewareByType(3).mediaCover_url"
                  alt=""
                /> -->
                
              </a-card>
            </div>
            <div v-for="(v, i) in getCoursewareListByType(5)" :key="i">
              <a-card v-if="selectedUnitType == 2">
                <h1>作业案例 {{i+1}}</h1>
                <a-divider></a-divider>
                <p class="unit-desc">
                  {{ v.mediaDesc }}
                </p>
                <img class="unit-cover" :src="v.mediaCover_url" alt="" />
                <div v-if="v.mediaPath_url && selectedUnit.isWorkOpen == 1">
                  <iframe
                    :src="handlePreviewMediaCode(v)"
                    id="workCaseFrameRef"
                    frameborder="0"
                    width="100%"
                  ></iframe>
                  <a-button
                  type="primary"
                  style="height: 34px; line-height: 34px;display: block;margin: auto;"
                  @click="handleViewMediaCode(v, false)"
                    >去做作业</a-button
                  >
                </div>
              </a-card>
            </div>
          </div>
        </a-spin>
      </a-layout-content>
      <a-layout-sider
        width="350"
        style="background: #fff"
        v-model="collapsed"
        :trigger="null"
        collapsible
      >
        <a-menu
          mode="inline"
          theme="dark"
          :defaultSelectedKeys="['1']"
          :style="{
            width: '350px',
            height: 'calc(100vh - 64px)',
            borderRight: 0,
            overflowY: 'auto',
            overflowX: 'hidden',
          }"
          :inline-collapsed="collapsed"
          @openChange="onOpenChange"
        >
          <a-sub-menu
            v-for="unit in courseUnits"
            :key="unit.unitId"
            :disabled="
              unit.isUnitOpen == 0 ||
              (unit.isUnitOpen == 2 && unit.openTime > unit.serverTime)
            "
          >
            <span slot="title">
              <a-icon
                type="form"
                v-if="
                  unit.isUnitOpen == 1 ||
                  (unit.isUnitOpen == 2 && unit.openTime < unit.serverTime)
                "
              />
              <a-icon type="lock" v-else />
              <span>{{ unit.unitName }}</span>
            </span>
            <a-menu-item @click="selectUnit(unit, 1)">
              {{ unit.unitName }}&nbsp;课堂案例
            </a-menu-item>
            <a-menu-item v-if="unit" @click="selectUnit(unit, 2)">
              {{ unit.unitName }}&nbsp;作业案例
            </a-menu-item>
          </a-sub-menu>
        </a-menu>
      </a-layout-sider>
    </a-layout>
  </div>
</template>

<script>
import Vue from "vue";
import store from "@/store";
import {
  getTeacherCourse,
  getStudentCourseUnit,
  getCourseCourseware,
} from "@/api/course";
export default {
  name: "StudentCourseUnitList",
  data() {
    return {
      departId: "",
      courseId: "",
      courseInfo: {},
      courseUnits: [],
      selectedUnit: {},
      selectedUnitType: 1,
      selectedMedia: [],
      collapsed: false,
      openKeys: [],
      showCourseInfo: true,
      showUnitInfo: false,
      isWorkOpen: false,
      isWorkCaseOpen: false,
      spinning: true,
    };
  },
  created() {
    this.courseId = this.$route.query.courseId;
    this.departId = this.$route.query.departId;
    this.getCourse();
    this.getCourseUnit();

    //需要登录的页面
    document.addEventListener("tokenInvaild", function (e) {
      // that.$router.push({
      //   path: `/user/login?role=student`,
      // });
      store.dispatch("Logout").then(() => {
        Vue.ls.remove(ACCESS_TOKEN);
        window.document.location = `/user/login?role=student`;
      });
    });
  },
  mounted() {
    var that = this;
    //scratch全屏
    document.addEventListener("scratchFullScreen", function (e) {
      that.launchIntoFullscreen(document.getElementById("player"));
    });
    //scratch退出全屏
    document.addEventListener("scratchUnFullScreen", function (e) {
      that.exitFullscreen();
    });
    //scratch获取焦点
    document.addEventListener("scratchInit", function (e) {
      var p = document.getElementById("player");
      var s = p.contentDocument.getElementById("scratch");
      s.addEventListener("click", () => {
        p.focus();
      });
    });
  },
  methods: {
    getCourse() {
      this.showCourseInfo = true;
      this.showUnitInfo = false;
      this.selectedUnit = {};
      getTeacherCourse({ courseId: this.courseId }).then((res) => {
        if (res.result && res.result.length > 0) {
          this.courseInfo = res.result[0];
        }
      });
    },
    getCourseUnit() {
      this.spinning = true;
      getStudentCourseUnit(this.departId, this.courseId, 1, 999).then((res) => {
        this.courseUnits = res.result.records;
        this.spinning = false;
      });
    },
    //选择单元
    selectUnit(unit, type) {
      console.log(unit);
      this.selectedUnitType = type;
      if (this.selectedUnit.id == unit.id) {
        return;
      }
      this.spinning = true;
      this.showCourseInfo = false;
      this.showUnitInfo = false;
      this.selectedUnit = unit;
      this.isWorkOpen = unit.isWorkOpen == 1 ? true : false;
      this.isWorkCaseOpen = unit.isWorkCaseOpen == 1 ? true : false;
      this.selectedMedia = [];
      getCourseCourseware(unit.unitId)
        .then((res) => {
          if (res.success) {
            this.selectedMedia = res.result;
          }
        })
        .finally(() => {
          this.spinning = false;
          this.showUnitInfo = true;
        });
    },
    handlePreviewMediaCode(mediaInfo) {
      // var mediaInfo = this.getCoursewareByType(mediaType);
      if (mediaInfo == null) {
        return "about:blank";
      }
      var mediaUrl = mediaInfo.mediaPathRaw_url || mediaInfo.mediaPath_url;
      if (mediaUrl == null) {
        return "about:blank";
      }
      var url;
      switch (mediaInfo.codeType) {
        case 1:
          url = "/scratch3/player.html?projectURL=" + mediaUrl;
          break;
        case 2:
          url = "/scratch3/player.html?projectURL=" + mediaUrl;
          break;
        case 3:
          url = "/scratchjr/editor.html?mode=edit&filepath=" + mediaUrl;
          break;
        case 4:
          url = "/onlinecode/player.html?lang=turtle&url=" + mediaUrl;
          break;
        case 5:
          url = "/onlinecode/player.html?lang=python&url=" + mediaUrl;
          break;
        case 6:
          url = "/onlinecode/player.html?lang=c&url=" + mediaUrl;
          break;
        case 7:
          url = "/onlinecode/player.html?lang=cpp&url=" + mediaUrl;
          break;
        case 8:
          url = "/onlinecode/player.html?lang=java&url=" + mediaUrl;
          break;
        default:
          url = "/scratch3/player.html?projectURL=" + mediaUrl;
      }
      return url;
    },
    handleViewMediaCode(mediaInfo, isRaw) {
      var mineWork = true;
      // var mediaInfo = this.getCoursewareByType(mediaType);
      if (mediaInfo == null) {
        return;
      }
      var url;
      switch (mediaInfo.codeType) {
        case 1:
          url =
            "/scratch3/index.html?scene=course&mediaId=" +
            mediaInfo.id +
            "&isRaw=" +
            isRaw;
          break;
        case 2:
          url =
            "/scratch3/index.html?scene=course&mediaId=" +
            mediaInfo.id +
            "&isRaw=" +
            isRaw;
          break;
        case 3:
          url =
            "/scratchjr/editor.html?scene=course&mode=edit&filepath=" +
            mediaInfo.workFile_url;
          break;
        case 4:
          url =
            "/onlinecode/index.html?scene=course&lang=turtle&mediaId=" +
            mediaInfo.id;
          break;
        case 5:
          url =
            "/onlinecode/index.html?scene=course&lang=python&mediaId=" +
            mediaInfo.id;
          break;
        case 6:
          url =
            "/onlinecode/index.html?scene=course&lang=c&mediaId=" +
            mediaInfo.id;
          break;
        case 7:
          url =
            "/onlinecode/index.html?scene=course&lang=cpp&mediaId=" +
            mediaInfo.id;
          break;
        case 8:
          url =
            "/onlinecode/index.html?scene=course&lang=java&mediaId=" +
            mediaInfo.id;
          break;
        default:
          url =
            "/scratch3/index.html?scene=course&mediaId=" +
            mediaInfo.id +
            "&isRaw=" +
            isRaw;
      }
      url += "&departId=" + this.departId;
      url += "&unitId=" + this.selectedUnit.unitId;
      // if(mineWork && mediaInfo.mineWorkId){
      //   url += "&workId=" + mediaInfo.mineWorkId;
      // }
      window.open(url);
    },
    //根据课件类型获取课件
    getCoursewareByType(type) {
      for (var i = 0; i < this.selectedMedia.length; i++) {
        if (this.selectedMedia[i].mediaType == type) {
          return this.selectedMedia[i];
        }
      }
      return false;
    },
    //根据课件类型获取课件列表
    getCoursewareListByType(type) {
      let courseWareList = [];
      for (var i = 0; i < this.selectedMedia.length; i++) {
        if (this.selectedMedia[i].mediaType == type) {
          courseWareList.push(this.selectedMedia[i]);
        }
      }
      return courseWareList;
    },
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },
    onOpenChange(openKeys) {
      const rootSubmenuKeys = this.courseUnits.map((item) => {
        return item.id;
      });
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      );
      if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    launchIntoFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    },
    exitFullscreen() {
      if (window.document.exitFullscreen) {
        window.document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        window.document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        window.document.webkitExitFullscreen();
      }
    },
  },
};
</script>

<style lang="less" scoped>
::-webkit-scrollbar {
  width: 6px;
  background: #ebebeb;
}
::-webkit-scrollbar-thumb {
  background: #abaaaa;
  border-radius: 3px;
}
iframe {
  display: block;
  width: 700px;
  height: 600px;
  margin: 20px auto;
}
header {
  background: #323545;
  height: 64px;
  padding: 16px;
  .ant-row {
    justify-content: center;
    margin: 0 auto;
  }
  .lesson-title {
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 20px;
    line-height: 28px;
    color: #fff;
    font-weight: 700;
  }
  .lesson-type {
    padding: 2px 6px;
    -webkit-box-shadow: 0 2px 4px 0 rgba(174, 104, 0, 0.1);
    box-shadow: 0 2px 4px 0 rgba(174, 104, 0, 0.1);
    border-radius: 10px;
    border: 1px solid rgba(255, 153, 0, 0.4);
    font-size: 12px;
    line-height: 15px;
    color: #f90;
    font-weight: 400;
    margin-left: 8px;
  }
  .lesson-download,
  .return-course {
    font-size: 14px;
    line-height: 20px;
    color: var(--primary-color);
    margin: 20px;
  }
}
.course-prepare-layout {
  min-height: calc(100vh - 68px);
}
.ant-layout {
  padding: 0 !important;
}
.btn-wrap {
  margin-top: 50px;
  text-align: center;
  a,
  button {
    display: inline-block;
    cursor: pointer;
    width: 100px;
    height: 40px;
    margin-right: 16px;
    border: 1px solid var(--primary-color);
    border-radius: 30px;
    line-height: 40px;
    font-size: 16px;
    text-align: center;
  }
}

.course-info {
  max-width: 800px;
  margin: auto;
  .ant-row {
    margin: 20px 0;

    img {
      max-width: 800px;
      display: block;
      margin: auto;
    }
  }
  .course-meta-title {
    color: #494949;
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
  }
  .course-meta-value {
    color: #494949;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
  }
}
.unit-info {
  max-width: 800px;
  margin: auto;
  .ant-card {
    margin: 20px 0;
    .unit-name {
      text-align: center;
      font-size: 24px;
      color: #333333;
      line-height: 33px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .unit-cover {
      display: block;
      margin: auto;
      width: 90%;
    }
    .unit-desc {
      font-size: 18px;
      color: #999999;
      line-height: 25px;
      padding: 0 20px;
    }
    .unit-video {
      display: block;
      margin: 20px auto;
      width: 90%;
    }
  }
}
</style>